<div class="px-3">
  <div *ngIf="content.specialties" class="ps-1 pt-3">
    <b class="text-break py-md-1" [attr.data-test-id]="'specialties-title'">
      {{ 'PROFILE_VIEW_SPECIALIZATION_HINT' | translate }}:
    </b>
    <span [attr.data-test-id]="'specialties-definition'">
      {{ content.specialties | formatCategories }}
    </span>
  </div>

  <div *ngIf="content.diseases" class="ps-1 pt-1">
    <b class="text-break py-md-1" [attr.data-test-id]="'diseases-title'">
      {{ 'FORM_CONSTRUCTOR_PROFILE_ORGANIZATION_DISEASES_LABEL' | translate }}:
    </b>
    <span [attr.data-test-id]="'diseases-definition'">
      {{ content.diseases | formatCategories }}
    </span>
  </div>

  <div *ngIf="content.organization_type" [ngClass]="{ 'pb-3': !content.website }" class="ps-1 pt-1">
    <b class="text-break py-md-1" [attr.data-test-id]="'organization_type-title'">
      {{ 'FORM_CONSTRUCTOR_PROFILE_ORGANIZATION_ORGANIZATION_TYPE_LABEL' | translate }}:
    </b>
    <span [attr.data-test-id]="'organization_type'">
      {{ getOrganizationType | translate }}
    </span>
  </div>

  <div *ngIf="content.website" class="ps-1 pt-1 pb-3">
    <b class="text-break py-md-1" [attr.data-test-id]="'website-title'">
      {{ 'FORM_CONSTRUCTOR_PROFILE_ORGANIZATION_WEBSITE_LABEL' | translate }}:
    </b>
    <a data-test-id="website" class="text-break py-md-1" [href]="normalizedLink" target="_blank">
      {{ content.website }}
    </a>
  </div>
</div>
